import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-92" data-mp="c6iqbhenhf1c">
      <div className="max-w-3xl mx-auto" data-id="element-93" data-mp="c4o8ibyoe31h">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-94" data-mp="84nqkhcdb9po">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight mb-6" data-id="element-95" data-mp="vwukl9umf4lx">
            Tu{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-96" data-mp="14uohalwas09m">
              paz mental
            </span>{' '}
            también merece protección
          </h2>
          <p className="text-ink-soft text-base md:text-lg mb-3 max-w-2xl mx-auto" data-id="element-97" data-mp="2c56ewecbmno5">
            No siempre podés controlar cómo actúan los demás.
          </p>
          <p className="text-ink-soft text-base md:text-lg max-w-2xl mx-auto mb-6" data-id="element-98" data-mp="2h5u4cvkwiwg9">
            Pero sí podés aprender a:
          </p>
          <ul className="text-left max-w-md mx-auto space-y-2 mb-8 text-ink-soft" data-id="element-99" data-mp="2r1nmcuhe3i5f">
            {['entender mejor ciertas dinámicas', 'poner límites', 'responder con más claridad', 'y dejar de vivir emocionalmente agotado'].map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-100" data-mp="34t27b6uuxtf4" data-mpi={i}>
                <span className="text-rose mt-1" data-id="element-101" data-mp="34voh7d580l0i">🌸</span>
                {t}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10" data-id="element-102" data-mp="3esjdrqhxobc5">
          <div className="text-center mb-6" data-id="element-103" data-mp="1si87fy5xxchz">
            <div className="inline-flex items-center gap-2 bg-rose-bg text-rose px-3 py-1 rounded-full mb-4" data-id="element-104" data-mp="1nq6uea0y7hqw">
              <span className="text-[11px] font-bold tracking-widest" data-id="element-105" data-mp="22ebenifng1bs">
                ⭐ OFERTA ESPECIAL
              </span>
            </div>
            <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink uppercase tracking-tight leading-tight" data-id="element-106" data-mp="1xfi1xs86seco">
              Cómo Trabajar con{' '}
              <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-107" data-mp="27de8s7u3cn4z">
                Gente Complicada
              </span>
            </h3>
            <p className="font-serif-italic text-rose text-base mt-1" data-id="element-108" data-mp="h3ktz6u20rws">
              6 Módulos + 5 Bonus
            </p>
          </div>

          {/* Mockup */}
          <div className="flex justify-center mb-6" data-id="element-109" data-mp="2x13ts5n6c9a">
            <img src="https://cdn.magicpatterns.com/uploads/7vb5BSSJbz8Kc6emHvnBm7/como_trabajar_con_gente_complicada.png" alt="Ebook Cómo Trabajar con Gente Complicada" className="h-52 md:h-60 w-auto object-contain drop-shadow-xl" data-id="element-110" data-mp="6xjuhivstc9w" />
          </div>

          <div className="text-center mb-6" data-id="element-111" data-mp="3fdd37bjw1jge">
            <div className="text-muted line-through mb-1 text-[14px]" data-id="element-112" data-mp="3fclgyrc6ky2s">
              $39.980+$46.000
            </div>
            <div className="flex items-baseline justify-center gap-2" data-id="element-113" data-mp="3kdrc0vtbcxfh">
              <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-114" data-mp="36dq6h323t1to">
                $19.990
              </span>
              <span className="text-base text-ink-soft" data-id="element-115" data-mp="3bc1gpewb9ecf">ARS</span>
            </div>
            <div className="text-sm text-muted mt-2" data-id="element-116" data-mp="14lv278i6fzlh">
              Pago único · Acceso de por vida
            </div>
          </div>

          <a href="https://checkout.aula-mater.online/cart/66742180839469:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-117" data-mp="19i266vr0j10s">
            <ArrowRightIcon className="w-5 h-5" data-id="element-118" data-mp="2hvvwgssv1kw5" />
            QUIERO ACCEDER AHORA
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-119" data-mp="2cwt0ryyrsr0u">
            <span className="flex items-center gap-1.5" data-id="element-120" data-mp="27xy885b03o3j">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-121" data-mp="23ww7tl5cl5zz" /> Pago 100% seguro
            </span>
            <span className="text-line" data-id="element-122" data-mp="1z0fi4mii2jks">|</span>
            <span className="flex items-center gap-1.5" data-id="element-123" data-mp="eh2aesn5n36c">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-124" data-mp="egagdm97hdi6" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-125" data-mp="jeu0ri85ih8f">|</span>
            <span className="flex items-center gap-1.5" data-id="element-126" data-mp="nhqofncjt3j8">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-127" data-mp="ni9w8b8hibjj" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-128" data-mp="sg1x3ur3x7zv">|</span>
            <span className="flex items-center gap-1.5" data-id="element-129" data-mp="3rwi27bdr7ktk">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-130" data-mp="3rtvn8qoja31b" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}